import React from 'react'
import styled from 'styled-components'

const FeedContainer = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  gap: 10px;

  @media only screen and (min-width: 992px) {
    gap: 17px;
  }
`

const Designs = ({ children }) => {
  return <FeedContainer>{children}</FeedContainer>
}

export default Designs
